import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Join from "../pages/join/page";
import Community from "../pages/community/page";
import Admin from "../pages/admin/page";
import Profile from "../pages/profile/page";
import MyProfile from "../pages/my-profile/page";
import CompleteRegistration from "../pages/complete-registration/page";
import Event from "../pages/event/page";
import SubmitBanner from "../pages/submit-banner/page";
import MyBanners from "../pages/my-banners/page";
import Depoimento from "../pages/depoimento/page";
import ResetPassword from "../pages/reset-password/page";
import UpcomingEvent from "../pages/upcoming-event/page";
import UpcomingEventPayment from "../pages/upcoming-event/payment/page";
import ConfirmAttendance from "../pages/confirm-attendance/page";
import ModerateBanner from "../pages/moderate-banner/page";
import Checkin from "../pages/checkin/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cadastro",
    element: <Join />,
  },
  {
    path: "/completar-cadastro",
    element: <CompleteRegistration />,
  },
  {
    path: "/comunidade",
    element: <Community />,
  },
  {
    path: "/perfil/:id",
    element: <Profile />,
  },
  {
    path: "/meu-perfil",
    element: <MyProfile />,
  },
  {
    path: "/depoimento",
    element: <Depoimento />,
  },
  {
    path: "/evento/:slug",
    element: <Event />,
  },
  {
    path: "/proximo-evento/:slug",
    element: <UpcomingEvent />,
  },
  {
    path: "/proximo-evento/:slug/pagamento",
    element: <UpcomingEventPayment />,
  },
  {
    path: "/confirmar-presenca/:registrationId",
    element: <ConfirmAttendance />,
  },
  {
    path: "/moderar-anuncio/:id",
    element: <ModerateBanner />,
  },
  {
    path: "/checkin/:eventId",
    element: <Checkin />,
  },
  {
    path: "/enviar-anuncio",
    element: <SubmitBanner />,
  },
  {
    path: "/meus-anuncios",
    element: <MyBanners />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "/recuperar-senha",
    element: <ResetPassword />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;